import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f1c51f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heading-4 f-roboto fw-light" }, "EPX Dashboard", -1))
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "box-title" }, "Report Dashboard", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "white-box" }
const _hoisted_6 = { class: "text-center heading-4 grey-1 fz-24 period-indicator mb-32" }
const _hoisted_7 = { class: "d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_report_quadrant = _resolveComponent("report-quadrant")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, {
    "no-sidebar": false,
    style: {"padding":"34px"}
  }, {
    "header-left": _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_DropDown, { class: "ml-20" }, {
          label: _withCtx(() => [
            _createTextVNode(" Year: " + _toDisplayString(_ctx.year), 1)
          ]),
          list: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearList, (year) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (_ctx.setYear(year)),
                key: year
              }, _toDisplayString(year), 9, _hoisted_4))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, "Year " + _toDisplayString(_ctx.year), 1),
        _createElementVNode("div", _hoisted_7, [
          (!!_ctx.report['q1'])
            ? (_openBlock(), _createBlock(_component_report_quadrant, {
                key: 0,
                title: "Q1",
                "period-from": "Nov",
                "period-to": "Jan",
                quadrant: _ctx.report.q1
              }, null, 8, ["quadrant"]))
            : _createCommentVNode("", true),
          (!!_ctx.report['q2'])
            ? (_openBlock(), _createBlock(_component_report_quadrant, {
                key: 1,
                title: "Q2",
                "period-from": "Feb",
                "period-to": "Apr",
                quadrant: _ctx.report.q2
              }, null, 8, ["quadrant"]))
            : _createCommentVNode("", true),
          (!!_ctx.report['q3'])
            ? (_openBlock(), _createBlock(_component_report_quadrant, {
                key: 2,
                title: "Q3",
                "period-from": "May",
                "period-to": "Jul",
                quadrant: _ctx.report.q3
              }, null, 8, ["quadrant"]))
            : _createCommentVNode("", true),
          (!!_ctx.report['q4'])
            ? (_openBlock(), _createBlock(_component_report_quadrant, {
                key: 3,
                title: "Q4",
                "period-from": "Aug",
                "period-to": "Oct",
                quadrant: _ctx.report.q4
              }, null, 8, ["quadrant"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}